import { useEffect } from "react";
import { useChat } from "./useChat";

const CHANNEL_POLL_MS = 5_000;
const SIDEBAR_POLL_MS = 150_000;

/**
 * HTTP-Polling-Fallback solange der WebSocket nicht verbunden ist
 * (Firmen-Proxys blocken teils den WSS-Upgrade komplett — KOL-27).
 * Einmal in ChatPage mounten. Pollt den aktiven Channel alle 5s und
 * die Channel-Liste (Sidebar-Unreads) alle 150s, bis der Socket
 * wieder verbindet. Bei Reconnect räumt der Effect-Cleanup beide
 * Timer ab; die WS-Events übernehmen wieder.
 */
export function useWsFallbackPolling(): void {
  const connectionState = useChat((s) => s.connectionState);
  const activeChannelId = useChat((s) => s.activeChannelId);

  useEffect(() => {
    if (connectionState === "connected") return;

    const msgTimer = activeChannelId
      ? setInterval(() => {
          void useChat.getState().loadMessages(activeChannelId);
        }, CHANNEL_POLL_MS)
      : null;
    const sidebarTimer = setInterval(() => {
      void useChat.getState().loadChannels();
    }, SIDEBAR_POLL_MS);

    return () => {
      if (msgTimer) clearInterval(msgTimer);
      clearInterval(sidebarTimer);
    };
  }, [connectionState, activeChannelId]);
}
